import * as constants from '../constants';
const defaultState = {
    payments: [],
    subscriptionPlans: [],
    couponApplied: false,
    couponAppliedPlans: [],
    freeTrial: false,
    paymentFailed: false,
    paymentFailedModal: false,
    freeTrialModal: false,
    shownFreeTrail: false,
    subscriptionStatus: {}
}

export default function paymentsReducer(state = defaultState, action) {
    switch (action.type) {
        case constants.RESET_PAYMENTS:
            return { ...defaultState, ...{ subscriptionStatus: {} } };
        case constants.GET_SUBSCRIPTION_PLAN:
            return { ...state, ...{ subscriptionPlans: action.payload } };
        case constants.GET_SUBSCRIPTION_STATUS:
            return {
                ...state,
                ...{ freeTrial: action.payload.freeTrial },
                ...{ paymentFailed: action.payload.paymentFailed },
                ...{
                    subscriptionStatus: action.payload
                }
            };
        case constants.GET_COUPON_APPLIED_STATUS:
            return { ...state, ...{ couponApplied: true, couponAppliedPlans: action.payload } };
        case constants.UPDATE_FREE_TRIAL_MODAL:
            return { ...state, ...{ freeTrialModal: action.payload } };
        case constants.UPDATE_PAYMENT_FAILED_MODAL:
            return { ...state, ...{ paymentFailedModal: action.payload } };
        case constants.FREE_TRAIL_SHOWN:
            return { ...state, ...{ shownFreeTrail: action.payload } }
        default:
            return state;
    }
}